module.exports = __webpack_public_path__ + "static/media/account.9e573a05.png";